import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 海报`}
          title={`${movie.title} ${movie.year} 影视资源`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-2 left-2 flex items-center gap-1 rounded-md bg-foreground-950/75 px-2 py-1 text-xs font-semibold text-accent-400 backdrop-blur">
          <i className="ri-star-fill text-[10px]" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute top-2 right-2 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-primary-950">
          {movie.category}
        </span>
      </div>
      <div className="p-3">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-700 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="w-1 h-1 rounded-full bg-background-400" />
          <span>{movie.region}</span>
        </div>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}